<template>
  <v-container class="py-10 py-md-13 py-lg-16 item">
    <TitleWidget>
      {{ title }}
    </TitleWidget>

    <v-sheet color="transparent" class="mt-6 mx-auto" max-width="500">
      <WorkWithUsForm
        :action="server + formAction"
        response-to="/trabalhe-conosco/obrigado"
      />
    </v-sheet>
  </v-container>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import WorkWithUsForm from "../components/forms/WorkWithUsForm.vue";

const _data = {
  title: "Trabalhe Conosco",
  formAction: "/rest/email/work-with-us",
};

export default {
  data: () => ({
    ..._data,
  }),
  components: {
    TitleWidget,
    WorkWithUsForm,
  },
};
</script>
